import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { API_CONFIG } from '../config/api';

const EditDioForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [naziv, setNaziv] = useState('');
  const [kataloskiBroj, setKataloskiBroj] = useState('');
  const [kolicina, setKolicina] = useState('');
  const [minimalnaKolicina, setMinimalnaKolicina] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState('');
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        try { setCurrentUser(JSON.parse(localStorage.getItem('user') || 'null')); } catch {}
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_CONFIG.ENDPOINTS.DIJELOVI}/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error('Greška prilikom dohvaćanja dijela.');
        const data = await res.json();
        setNaziv(data.naziv_dijela || '');
        setKataloskiBroj(data.kataloski_broj || '');
        setKolicina(String(data.dostupna_kolicina ?? ''));
        setMinimalnaKolicina(String(data.minimalna_kolicina ?? '0'));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_CONFIG.ENDPOINTS.DIJELOVI}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          naziv_dijela: naziv,
          kataloski_broj: kataloskiBroj,
          dostupna_kolicina: Number(kolicina),
          minimalna_kolicina: minimalnaKolicina === '' ? 0 : Number(minimalnaKolicina),
        }),
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || 'Greška prilikom ažuriranja.');
      }
      setSuccess('Dio je uspješno ažuriran.');
      setTimeout(() => navigate('/dijelovi'), 800);
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <div className="flex items-center justify-center min-h-[50vh] text-gray-600">Učitavanje...</div>;
  if (error) return (
    <div className="max-w-md mx-auto p-4">
      <div className="p-3 mb-4 text-sm text-red-700 bg-red-100 rounded-lg">Greška: {error}</div>
    </div>
  );

  return (
    <div className="max-w-md mx-auto">
      <div className="p-8 bg-white rounded-lg shadow-sm border border-gray-200 w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Uredi dio</h2>
        {success && <div className="p-3 mb-4 text-sm text-green-700 bg-green-100 rounded-lg">{success}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="naziv" className="block text-sm font-medium text-gray-700">Naziv dijela</label>
            <input id="naziv" type="text" value={naziv} onChange={(e) => setNaziv(e.target.value)} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
          </div>
          <div>
            <label htmlFor="kbroj" className="block text-sm font-medium text-gray-700">Kataloški broj</label>
            <input id="kbroj" type="text" value={kataloskiBroj} onChange={(e) => setKataloskiBroj(e.target.value)} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
          </div>
          <div>
            <label htmlFor="kolicina" className="block text-sm font-medium text-gray-700">Dostupna količina</label>
            <input id="kolicina" type="number" min="0" value={kolicina} onChange={(e) => setKolicina(e.target.value)} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required />
          </div>
          {currentUser?.role === 'admin' && (
            <div>
              <label htmlFor="minKolicina" className="block text-sm font-medium text-gray-700">Minimalna količina (za upozorenje)</label>
              <input id="minKolicina" type="number" min="0" value={minimalnaKolicina} onChange={(e) => setMinimalnaKolicina(e.target.value)} className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm" />
            </div>
          )}
          <div className="flex gap-2">
            <button type="submit" className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors">Sačuvaj</button>
            <button type="button" onClick={() => navigate('/dijelovi')} className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300 transition-colors">Otkaži</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDioForm;
